import useResizeObserverBase, { UseResizeObserverCallback } from "@react-hook/resize-observer";

class ServerSideResizeObserverPolyfill {
  observe() {
    // no-op
  }
  unobserve() {
    // no-op
  }
}

export function useResizeObserver<T extends Element>(
  target: React.RefObject<T> | React.ForwardedRef<T> | T | null,
  callback: UseResizeObserverCallback,
) {
  return useResizeObserverBase(target, callback, {
    polyfill: typeof window === "undefined" ? ServerSideResizeObserverPolyfill : null,
  });
}
